/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CopyLeadRequest
 */
export interface CopyLeadRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof CopyLeadRequest
     */
    facility_ids: Array<string>;
}

/**
 * Check if a given object implements the CopyLeadRequest interface.
 */
export function instanceOfCopyLeadRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "facility_ids" in value;

    return isInstance;
}

export function CopyLeadRequestFromJSON(json: any): CopyLeadRequest {
    return CopyLeadRequestFromJSONTyped(json, false);
}

export function CopyLeadRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CopyLeadRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'facility_ids': json['facility_ids'],
    };
}

export function CopyLeadRequestToJSON(value?: CopyLeadRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'facility_ids': value.facility_ids,
    };
}

